import { render, staticRenderFns } from "./CounselorDropDown.vue?vue&type=template&id=36f8e910"
import script from "./CounselorDropDown.vue?vue&type=script&lang=js"
export * from "./CounselorDropDown.vue?vue&type=script&lang=js"
import style0 from "./CounselorDropDown.vue?vue&type=style&index=0&id=36f8e910&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports